import { render, staticRenderFns } from "./LoadingDots.vue?vue&type=template&id=d6423e0a&scoped=true"
var script = {}
import style0 from "./LoadingDots.vue?vue&type=style&index=0&id=d6423e0a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6423e0a",
  null
  
)

export default component.exports